<script lang="ts" setup>
import MarkDownIt from "markdown-it";

const md = new MarkDownIt({ html: true });

withDefaults(
  defineProps<{
    column1: string;
    column2: string;
  }>(),
  {},
);
</script>
<template>
  <article class="two-column-list prose grid grid-cols-2 gap-x-13">
    <div class="col" v-html="md.render(column1)" />
    <div class="col" v-html="md.render(column2)" />
  </article>
</template>
<style scoped>
.prose:deep(p + ul) {
  @apply mt-6;
}
</style>
